import { useState } from 'react';

export function VideoGallery() {
  const videos = [
    {
      title: "NH Velo Racing Team Highlights",
      url: "https://www.youtube.com/embed/yuceVIjsrEk?si=b2wCKgQP08xvY-0U"
    },
    {
      title: "NH Velo Racing Team Highlights",
      url: "https://www.youtube.com/embed/WF3DNECMHAI?si=qZvcONfnCXQ4nkDH"
    },
    {
      title: "NH Velo Racing Team Highlights",
      url: "https://www.youtube.com/embed/KeATOHBGe7c?si=HZkjdLS3UApGQ6GG"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Video Gallery</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {videos.map((video, index) => (
            <div key={index} className="aspect-video rounded-lg overflow-hidden shadow-lg">
              <iframe
                src={video.url}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}